// extracted by mini-css-extract-plugin
export default {"container":"Revenue_container__dneME","slider":"Revenue_slider__Q8H7m","first":"Revenue_first__yHzTs","second":"Revenue_second__3YQlL"};